import { ACTIONS } from '@~/actions/app-config';

const initialState = {
  canCalculateTalkTime: false,
  newRewardElementReceived: null,
};

export default function defaultExport(state = initialState, { type, payload }) {
  if (type === ACTIONS.TOGGLE_TALK_CALCULATOR) {
    const { isActive } = payload;

    return {
      ...state,
      canCalculateTalkTime: isActive,
    };
  }

  if (type === ACTIONS.NEW_REWARD_ELEMENT_RECEIVED) {
    const { name } = payload;

    return {
      ...state,
      newRewardElementReceived: name,
    };
  }

  return state;
}
